import CloseButton from './CloseButton';

export default CloseButton;


// WEBPACK FOOTER //
// /src/components/UiComponents/CloseButton/index.js